import * as React from 'react';
import sanitizeHtml from 'sanitize-html';

import { __t, applyTranslations } from 'utils/language';

applyTranslations(require('./recaptcha-terms-and-policy.i18n.json'));

class RecaptchaTermsAndPolicy extends React.PureComponent {
  buildTermsOfUseMarkup() {
    const params = {
      privacy:
        `<a class="signup__tos-link" target="_blank" href="https://policies.google.com/privacy">${__t('recaptcha_terms_and_policy.privacy_policy')}</a>`,
      terms:
        `<a class="signup__tos-link" target="_blank" href="https://policies.google.com/terms">${__t('recaptcha_terms_and_policy.terms_of_usage')}</a>`
    };

    return sanitizeHtml(__t('recaptcha_terms_and_policy.title', params), {
      allowedAttributes: {
        a: ['href', 'target', 'class']
      }
    });
  }

  render() {
    return (
      <small
        className="signup__tos"
        dangerouslySetInnerHTML={{ __html: this.buildTermsOfUseMarkup() }}
      />
    );
  }
}

export default RecaptchaTermsAndPolicy;
